module.exports = __webpack_public_path__ + "img/Disaster-2.a0ee1948.jpg";